import { render, staticRenderFns } from "./LabelContractsSplitsReadOnlyPanel.vue?vue&type=template&id=4c271fee"
import script from "./LabelContractsSplitsReadOnlyPanel.vue?vue&type=script&lang=js"
export * from "./LabelContractsSplitsReadOnlyPanel.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports